// API service for Nexite website
function getApiBaseUrl() {
  const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
  if (configuredBaseUrl) {
    return configuredBaseUrl.replace(/\/$/, "");
  }

  if (process.env.NODE_ENV === "production") {
    if (typeof window !== "undefined" && window.location?.origin) {
      return window.location.origin;
    }

    return "https://nexite.com.pk";
  }

  return "http://localhost:5000";
}

const API_BASE_URL = getApiBaseUrl();

export const contactAPI = {
  /**
   * Submit contact form data
   * @param {Object} formData - Contact form data
   * @returns {Promise<Object>} Response from server
   */
  async submitContactForm(formData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json().catch(() => ({
        error: 'Unexpected server response'
      }));

      if (!response.ok) {
        throw new Error(data.error || 'Failed to send message');
      }

      return data;
    } catch (error) {
      console.error('Contact form submission error:', error);
      
      // Enhanced fallback: Create a mailto link and provide clear instructions
      if (error.name === 'TypeError' || error.message.includes('fetch')) {
        const emailSubject = encodeURIComponent(`[Nexite Contact] ${formData.subject}`);
        const emailBody = encodeURIComponent(
          `Name: ${formData.name}\n` +
          `Email: ${formData.email}\n` +
          `Phone: ${formData.phone || 'Not provided'}\n` +
          `Topic: ${formData.topic || 'General Inquiry'}\n\n` +
          `Message:\n${formData.message}`
        );
        
        const mailtoLink = `mailto:info.nexite@gmail.com?subject=${emailSubject}&body=${emailBody}`;
        
        // Try to open email client in a new tab/window
        try {
          window.open(mailtoLink, '_blank');
          return { 
            success: true, 
            message: 'Email client opened with your message. Please click Send in your email application.',
            fallback: true 
          };
        } catch (mailtoError) {
          // If mailto fails, provide manual instructions
          return {
            success: false,
            message: `Please send your message manually to info.nexite@gmail.com with subject "${formData.subject}"`,
            fallback: true,
            contactInfo: {
              email: 'info.nexite@gmail.com',
              phone: '+92 323 5522788',
              subject: formData.subject,
              message: formData.message
            }
          };
        }
      }
      
      throw error;
    }
  },

  /**
   * Check backend health
   * @returns {Promise<Object>} Health status
   */
  async checkHealth() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/health`);
      return await response.json();
    } catch (error) {
      console.error('Health check failed:', error);
      throw error;
    }
  }
};

export default contactAPI;